import { SourcingAllyEventTypes } from "./enums";

export interface SourcingAllyEvent {
    eventId: string;
    eventType: SourcingAllyEventTypes;
    userId: string;
    eventDate: number;
    subjectId?: string;
}